import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
// import toast from "react-hot-toast";
import Cookies from "js-cookie";
import {Notification} from "../../Notification"

const TranseferCODModal = ({ id, onClose }) => {
    const [remittance, setRemittance] = useState(null);
    const [bankDetails, setBankDetails] = useState(null);
    const [utr, setUtr] = useState("");
    const [loading, setLoading] = useState(false);
    const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        const fetchCodTransfer = async () => {
            if (!id) return;
            try {
                const token = Cookies.get("session");
                const response = await axios.get(
                    `${REACT_APP_BACKEND_URL}/cod/getCODTransferData/${id}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setRemittance(response.data.data[0]);
                setBankDetails(response.data.bankDetails || null);
            } catch (error) {
                console.error("Error fetching remittance data:", error);
            }
        };

        fetchCodTransfer();
    }, [id, REACT_APP_BACKEND_URL]);

    const handleSubmit = async () => {
        if (!utr.trim()) {
            Notification("Please enter UTR","info");
            return;
        }
        setLoading(true);
        try {
            const token = Cookies.get("session");
            const response = await axios.post(
                `${REACT_APP_BACKEND_URL}/cod/transferCOD/${id}`,
                { utr },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            Notification(response?.data?.message || "UTR submitted successfully","success");
            onClose();
        } catch (error) {
            console.error("Error submitting UTR:", error);
            Notification(error?.response?.data?.message || "Failed to submit UTR","error")
            alert(error?.response?.data?.message || "Failed to submit UTR");
        } finally {
            setLoading(false);
        }
    };

    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <motion.div
                    className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl p-4 relative overflow-y-auto max-h-[90vh]"
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.9, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 200, damping: 20 }}
                >
                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        aria-label="Close modal"
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition"
                    >
                        ✕
                    </button>

                    {/* Title */}
                    <h2
                        id="modal-title"
                        className="text-[14px] sm:text-[16px] font-[600] mb-4 text-gray-700 border-b pb-2"
                    >
                        Transfer COD Details
                    </h2>

                    {/* Loading State */}
                    {!remittance ? (
                        <div className="space-y-4">
                            <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>
                            <div className="h-6 bg-gray-200 rounded animate-pulse w-2/3"></div>
                            <div className="h-6 bg-gray-200 rounded animate-pulse w-1/3"></div>
                        </div>
                    ) : (
                        <>
                            {/* Bank Details */}
                            {bankDetails && (
                                <div className="mb-2 p-4 border border-gray-200 rounded-lg bg-purple-50 shadow-sm">
                                    <h3 className="sm:text-[14px] text-[12px] font-[600] mb-2 text-gray-700">
                                        Bank Details
                                    </h3>
                                    <div className="grid grid-cols-2 gap-2 text-gray-700 text-[10px] sm:text-[12px]">
                                        <div>
                                            <span className="font-[600]">Account Holder:</span>{" "}
                                            {bankDetails.nameAtBank || "-"}
                                        </div>
                                        <div>
                                            <span className="font-[600]">Account Number:</span>{" "}
                                            {bankDetails.accountNumber || "-"}
                                        </div>
                                        <div>
                                            <span className="font-[600]">Bank:</span>{" "}
                                            {bankDetails.bank || "-"}
                                        </div>
                                        <div>
                                            <span className="font-[600]">Branch:</span>{" "}
                                            {bankDetails.branch || "-"}
                                        </div>
                                        <div>
                                            <span className="font-[600]">City:</span>{" "}
                                            {bankDetails.city || "-"}
                                        </div>
                                        <div>
                                            <span className="font-[600]">IFSC:</span>{" "}
                                            {bankDetails.ifsc || "-"}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Remittance Summary */}
                            <section className="mb-4 grid grid-cols-2 gap-x-2 gap-y-2 text-gray-700 text-[10px] sm:text-[12px]">
                                <div>
                                    <span className="font-[600]">COD To Be Remitted:</span> ₹
                                    {remittance.CODToBeRemitted}
                                </div>
                                <div>
                                    <span className="font-[600]">Last COD Remitted:</span> ₹
                                    {remittance.LastCODRemitted}
                                </div>
                                <div>
                                    <span className="font-[600]">Remittance Initiated:</span> ₹
                                    {remittance.RemittanceInitiated}
                                </div>
                                <div>
                                    <span className="font-[600]">Total COD Remitted:</span> ₹
                                    {remittance.TotalCODRemitted?.toFixed(2)}
                                </div>
                                <div>
                                    <span className="font-[600]">Total Deduction:</span> ₹
                                    {remittance.TotalDeductionfromCOD?.toFixed(2)}
                                </div>
                            </section>

                            {/* Remittance Table */}
                            <section className="mb-4">
                                <h3 className="text-[12px] sm:text-[14px] font-[600] mb-2 text-gray-700">
                                    Remittance Data
                                </h3>
                                <div className="overflow-x-auto rounded-lg border border-gray-200 max-h-60 overflow-y-auto">
                                    <table className="w-full text-left border-collapse text-[10px] sm:text-[12px]">
                                        <thead className="bg-purple-50 sticky top-0">
                                            <tr>
                                                <th className="px-3 py-2 border-b">Remittance ID</th>
                                                <th className="px-3 py-2 border-b">Total COD Amount</th>
                                                <th className="px-3 py-2 border-b">Amount Credited to Wallet</th>
                                                <th className="px-3 py-2 border-b">Early COD Charges</th>
                                                <th className="px-3 py-2 border-b">Remittance Amount</th>
                                                <th className="px-3 py-2 border-b">Status</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {remittance.remittanceData?.length > 0 ? (
                                                remittance.remittanceData.map((item) => (
                                                    <tr
                                                        className="border-b hover:bg-gray-50 transition"
                                                        key={item._id || item.remittanceId}
                                                    >
                                                        <td className="px-3 py-2 text-[#632C9D]">
                                                            {item.remittanceId || "N/A"}
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            ₹{(item.codAvailable + item.amountCreditedToWallet + item.earlyCodCharges).toFixed(2) || "0.00"}
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            ₹{item.amountCreditedToWallet?.toFixed(2) || "0.00"}
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            ₹{item.earlyCodCharges?.toFixed(2) || "0.00"}
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            ₹{item.codAvailable?.toFixed(2) || "0.00"}
                                                        </td>
                                                        <td className="px-3 py-2 capitalize text-orange-500">
                                                            {item.status || "N/A"}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan={3}
                                                        className="px-4 py-6 text-center text-gray-500"
                                                    >
                                                        No remittance data found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </section>

                            {/* UTR Input */}
                            <section className="mb-4">
                                <label
                                    htmlFor="utr"
                                    className="block text-gray-700 font-[600] mb-2 text-[10px] sm:text-[12px]"
                                >
                                    Enter UTR
                                </label>
                                <input
                                    id="utr"
                                    type="text"
                                    value={utr}
                                    placeholder="Enter UTR here"
                                    onChange={(e) => setUtr(e.target.value)}
                                    className="w-5/2 px-3 py-2 text-[10px] sm:text-[12px] font-[600] text-gray-500 placeholder:text-gray-500 rounded-lg border border-gray-300 focus:outline-none transition"
                                />
                            </section>

                            {/* Actions */}
                            <div className="flex justify-end gap-4">
                                <button
                                    className="px-3 py-2 rounded-lg text-[10px] sm:text-[12px] font-[600] border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                                    onClick={onClose}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="px-3 py-2 text-[10px] sm:text-[12px] rounded-lg bg-[#632C9D] text-white font-[600] hover:bg-purple-700 focus:outline-none disabled:opacity-60 transition"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </>
                    )}
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default TranseferCODModal;
